import { Button } from "@wags/ui/button.tsx";
import type { ReactNode } from "react";
import { cn } from "@wags/ui/ui-utils";
import { AdoptionStatusRow } from "./adoption-status-row";
import type { ListingActionArea } from "./dog-listing-presentation";
import type {
    InlineContactAction,
    StatusContactAction,
} from "./use-dog-contact";

function ActionRowSentinel({
    onNode,
}: {
    onNode: (node: HTMLSpanElement | null) => void;
}) {
    return (
        <span
            ref={onNode}
            aria-hidden="true"
            className="pointer-events-none absolute bottom-18 left-0 size-px"
        />
    );
}

export function DogActionRow({
    action,
    inlineBuy,
    statusContact,
    onSentinel,
    onRow,
    contactHelp,
    className,
}: {
    action: ListingActionArea;
    inlineBuy: InlineContactAction;
    statusContact: StatusContactAction | null;
    onSentinel: (node: HTMLSpanElement | null) => void;
    onRow: (node: HTMLDivElement | null) => void;
    contactHelp: (cta: ReactNode) => ReactNode;
    className?: string;
}) {
    if (action.kind === "buy") {
        if (!action.contactable) return null;
        return (
            <div
                ref={onRow}
                className={cn("relative mt-6 dog-desktop:hidden", className)}
            >
                <ActionRowSentinel onNode={onSentinel} />
                {contactHelp(
                    <Button
                        type="button"
                        emphasis="lead"
                        size="primary-action"
                        className="w-full text-label"
                        aria-busy={inlineBuy.busy || undefined}
                        aria-label={inlineBuy.accessibleLabel}
                        onClick={inlineBuy.onClick}
                    >
                        {inlineBuy.label}
                    </Button>,
                )}
            </div>
        );
    }
    return (
        <div ref={onRow} className={cn("relative mt-6", className)}>
            <ActionRowSentinel onNode={onSentinel} />
            <AdoptionStatusRow status={action.status} contact={statusContact} />
        </div>
    );
}
